import { render, staticRenderFns } from "./SanID.vue?vue&type=template&id=9eb02d1a&"
import script from "./SanID.vue?vue&type=script&lang=ts&"
export * from "./SanID.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports